import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { CartContext } from "../Context/CartContext";
 
function Published() {
  const { addToCart, addToWishlist, wishlistItems } = useContext(CartContext);
  const navigate = useNavigate();
 
  // --- AUTHENTICATION CHECK ---
  const isLoggedIn = false;
  // ----------------------------
 
  const handleWishlistClick = (item) => {
    if (isLoggedIn) {
      addToWishlist(item);
    } else {
      navigate("/login");
    }
  };
 
  const handleCartClick = (item) => {
    if (isLoggedIn) {
      addToCart(item);
    } else {
      navigate("/login");
    }
  };
 
  const products = [
    {
      id: 1,
      title: "Death Of Sarat Rout",
      price: "₹299",
      img: "assets/img/shop/book.png"
    },
    {
      id: 2,
      title: "THE JOURNEY OF CBR",
      price: "₹175",
      img: "assets/img/shop/book1.png"
    },
    {
      id: 3,
      title: "SERU MY LOVE",
      price: "₹175",
      img: "assets/img/shop/book2.png"
    },
    // {
    //   id: 4,
    //   title: "Wood Water Bottle",
    //   price: "₹199",
    //   img: "assets/img/shop/shop3-image4.png"
    // }
  ];
 
  return (
    <>
      <Header />
     
      {/* CSS Styles to fix the UI layout */}
      <style>{`
        /* Make the content area a vertical flex column */
        .shop-card-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 20px 10px;
        }
 
        .product-title {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 10px;
            color: #1a1a1a;
            min-height: 50px; /* Aligns cards if titles have different lengths */
            display: flex;
            align-items: center;
            justify-content: center;
        }
 
        /* Large, Eye-Catching Price Style */
        .big-price {
            font-size: 20px; /* Very large text */
            font-weight: 700; /* Extra Bold */
            color: #ff5e14; /* Theme Orange */
            margin-bottom: 15px; /* Space between Price and Button */
            line-height: 1;
            cursor: default;
           
            padding: 4px 8px;
            border: 2px solid #ff5e14; /* Bold border */
            border-radius: 8px; /* Slightly rounded corners */
         
           
        }
 
        /* Ensure the button has space to breathe */
        .add-cart-btn {
            width: 100%;
            max-width: 180px; /* Prevents it from being too wide */
            border-radius: 30px; /* Modern rounded corners */
        }
      `}</style>
 
      <div className="shop3-area sp sec-bg2">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto text-center">
              <div className="heading3">
                <span className="sub-title" data-aos="zoom-in-left" data-aos-duration={900}>
                  <img src="assets/img/icons/span4.svg" alt="" /> MY Published Books
                </span>
                <h2 className="text-anime-style-3">Our Showcase</h2>
              </div>
            </div>
          </div>
         
          {/* Product Cards */}
          <div className="row mt-40">
            {products.map((item, index) => (
              <div className="col-lg-3 col-md-6" key={item.id}>
                <div className="shop3-item mt-40 position-relative">
                  {/* Wishlist Icon */}
                  <button
                    className={`wishlist-btn ${
                      wishlistItems.some((i) => i.id === item.id) ? "active" : ""
                    }`}
                    onClick={() => handleWishlistClick(item)}
                  >
                    <i
                      className={`fa-heart ${
                        wishlistItems.some((i) => i.id === item.id)
                          ? "fa-solid"
                          : "fa-regular"
                      }`}
                    ></i>
                  </button>
                 
                  {/* Product Image */}
                  <div className="image-area">
                    <div className="image">
                      <img src={item.img} alt={item.title} />
                    </div>
                  </div>
 
                  {/* Product Content - NOW VERTICAL */}
                  <div className="content shop-card-content">
                   
                    {/* Title */}
                    <h6 className="product-title">{item.title}</h6>
                   
                    {/* Price - Large and above the button */}
                    <div className="big-price">{item.price}</div>
                   
                    {/* Add to Cart Button */}
                    <button
                        className="theme-btn7 add-cart-btn"
                        onClick={() => handleCartClick(item)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
 
export default Published;
 